import { IconButton } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { historyDownload } from "../../../../service/StudyViewerService";
import Download from "../../../../components/SVGComponents/Tools/Download";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import themeContext from "../../../../context/theme/ThemeContext";
import { t } from "i18next";
import MobileViewerContext from "../../../../context/studyviewer/MobileViewerContext";

const MobileHistoryBottomSheet = () => {
  const { getAlterColor } = useContext(themeContext);
  const { activeStudyId } = useContext(ThumbnailContext);
  const {
    studyParentId,
    studyHistoryData,
    parentChildReportsObj,
    studyClinicalNotesData,
  } = useContext(studyviewerContext);
  const { setShowHistory } = useContext(MobileViewerContext);

  // The advance viewer (MedDream iframe) never sets activeStudyId — only the
  // cornerstone Viewport/Thumbnail do. Treat an unset activeStudyId as the
  // parent study so this sheet shows data there instead of coming up empty.
  const isParentStudyActive = () =>
    activeStudyId == "" || activeStudyId == null || activeStudyId == studyParentId;

  const getStudyHistoryData = () => {
    if (studyParentId != null && studyParentId != undefined) {
      if (isParentStudyActive()) {
        return studyHistoryData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return parentChildReportsObj[activeStudyId]?.studyHistoryDocList;
        }
        return false;
      }
    }
  };

  const getStudyClinicalData = () => {
    if (studyParentId != null && studyParentId != undefined) {
      if (isParentStudyActive()) {
        return studyClinicalNotesData != null &&
          studyClinicalNotesData != undefined &&
          studyClinicalNotesData != ""
          ? studyClinicalNotesData
          : "No clinical notes available";
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null &&
          parentChildReportsObj[activeStudyId]?.history != ""
        ) {
          return parentChildReportsObj[activeStudyId].history;
        }
        return "No clinical notes available";
      }
    }
  };

  const [localStudyHistoryData, setLocalStudyHistoryData] = useState([]);

  useEffect(() => {
    setLocalStudyHistoryData(getStudyHistoryData);
  });

  const printPreviewHistoryDoc = async (historyDoc) => {
    let n = historyDoc.indexOf("/");
    let bucketName = historyDoc.substring(0, n);
    let result = historyDoc.substring(n + 1);
    let extension = getFileExtension(getFileName(result));
    let body = {
      studyId: studyParentId,
      filePath: result,
      bucketName: bucketName,
    };
    try {
      let res = await historyDownload(body, extension);
    } catch (e) {}
  };

  function getFileExtension(filename) {
    // get file extension
    const extension = filename.split(".").pop();
    return extension;
  }

  const getFileName = (str) => {
    let s = str.lastIndexOf("/");
    if (s != -1) {
      return str.substring(s + 1);
    }
    return "";
  };

  return (
    <div className="popup-viewer-content">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "15%",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <span className="study-list-mobile-filter-txt">
          History and Attachments
        </span>
        <div className="study-list-mobile-close-icon-div">
          <IconButton
            //style={{ color: "white" }}
            //style={{color : "var(--navbar-header-popup-color-txt)"}}
            style={{color: "var(--mobile-color-txt)"}}
            iconProps={{ iconName: "Cancel" }}
            ariaLabel="Close popup filter mobile"
            onClick={() => setShowHistory(false)}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-evenly",
          flexDirection: "column",
          height: "100%",
          borderBottom: "1px solid #3D3D3D",
          padding: "10px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            //style={{ color: "var(--navbar-header-popup-color-txt)", fontSize: "14px", fontWeight: "400" }}
            style={{color: "var(--mobile-color-txt)", fontSize: "14px", fontWeight: "400"}}
          >
            Clinical Notes:{" "}
          </span>
          <span
            style={{
              fontSize: "12px",
              maxHeight: "200px",
              overflowY: "auto",
              width: "95%",
              textAlign: "justify"
            }}
          >
            {getStudyClinicalData()}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "20px",
          }}
        >
          <span
            //style={{ color: "var(--navbar-header-popup-color-txt)", fontSize: "14px", fontWeight: "400" }}
            style={{color: "var(--mobile-color-txt)", fontSize: "14px", fontWeight: "400"}}
          >
            Attachments:{" "}
          </span>
          <>
            <ul className="dropdown-menu-history scrollable-menu modal-scroll-annotation  attachment-mobile-box">
              {localStudyHistoryData?.length > 0 ? (
                localStudyHistoryData?.map((report, index) => {
                  return (
                    <li
                      key={index}
                      onClick={(event) => {
                        printPreviewHistoryDoc(localStudyHistoryData[index]);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span
                          style={{ color: getAlterColor("#A19F9D", "#000") }}
                          className="report-name-text"
                        >
                          {getFileName(report)}
                        </span>

                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                          }}
                        >
                          {getFileExtension(getFileName(report)) == "doc" ||
                          getFileExtension(getFileName(report)) == "docx" ? (
                            <Download color={getAlterColor("#C1C1C1", "")} />
                          ) : (
                            <EyeIcon color={getAlterColor("#C1C1C1", "")} />
                          )}
                        </span>
                      </div>
                    </li>
                  );
                })
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    width: "95%",
                  }}
                >
                  No attachments present
                </span>
              )}
            </ul>
          </>
        </div>
      </div>
    </div>
  );
};

export default MobileHistoryBottomSheet;
